import { Link } from 'react-router-dom';
import { FooterContactInfo } from './FooterContactInfo.tsx';
import { FooterInfoLinks } from './FooterInfoLinks.tsx';
import { FooterCertLogos } from './FooterCertLogos';
import { useTranslation } from 'react-i18next';

export const Footer = () => {
  const { t } = useTranslation();

  const currentYear = new Date().getFullYear();

  return (
    <footer className='ltn__footer-area  '>
      <div className='footer-top-area  section-bg-2 plr--5'>
        <div className='container-fluid'>
          <div className='row'>
            <FooterContactInfo className='col-xl-3 col-md-6 col-sm-6 col-12' />
            <FooterInfoLinks className='col-xl-2 col-md-6 col-sm-6 col-12' />
            <FooterCertLogos className='col-xl-7 justify-content-xl-end col-12' />
          </div>
        </div>
      </div>
      <div className='ltn__copyright-area ltn__copyright-2 section-bg-7  plr--5'>
        <div className='container-fluid ltn__border-top-2'>
          <div className='row'>
            <div className='col-md-6 col-12'>
              <div className='ltn__copyright-design clearfix'>
                <p>
                  {t('footer.allRightsReserved')} {currentYear}
                </p>
              </div>
            </div>
            <div className='col-md-6 col-12 align-self-center'>
              <div className='ltn__copyright-menu text-end'>
                <ul>
                  <li>
                    <Link to='/privacy-policy'>
                      {t('footer.privacyPolicy')}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
